(function () {
  "use strict";

  function dispatch(func, doc) {
    // ensure that listeners bound to a document on the page ignore
    // events that could be triggered from child iframes, e.g. hovering
    // over an iframe can trigger a mouseover event from both within the iframe
    // and the iframe element itself, we want to ignore the latter.

    return function () {
      var slice = Array.prototype.slice,
        args = slice.apply(arguments),
        event = args[0],
        eventDoc = event ? event.target.ownerDocument : null;

      if (eventDoc && eventDoc.documentElement === doc) {
        return func.apply(this, [doc].concat(args));
      } else {
        return true;
      }
    };
  }

  function dragulish(containerSelectors, options) {
    var documents = [document.documentElement],
      _moveX,
      _moveY,
      _grabbed,
      _item,
      _initialSibling,
      _source,
      _renderTimer,
      _currentSibling,
      _lastDropTarget;

    var drake = {
      callbacks: {
        drag: [],
        move: [],
        out: [],
        over: [],
        dragend: [],
        cancel: [],
        drop: [],
        remove: [],
      },
      containers: function () {
        var containers = [];
        containerSelectors.forEach(function (selector) {
          documents.forEach(function (doc) {
            var result = doc.querySelectorAll(selector);
            result = Array.prototype.slice.call(result);
            if (result.length > 0) {
              containers = containers.concat(result);
            }
          });
        });
        return containers;
      },
      end: end,
      cancel: cancel,
      destroy: function (doc) {
        unbind();
        release(doc, {});
      },
      canMove: canMove,
      dragging: false,
      on: function (type, cb) {
        this.callbacks[type].push(cb);
      },
      emit: function () {
        var slice = Array.prototype.slice,
          args = slice.apply(arguments),
          type = args[0];
        this.callbacks[type].forEach(function (cb) {
          cb.apply(null, args.slice(1));
        });
      },
    };

    // add all iframes
    for (var i = 0; i < window.frames.length; i++) {
      var frame = window.frames[i];
      var frameDocumentElement;

      try {
        frameDocumentElement = frame.document.documentElement;
      } catch (e) {
        continue; // Iframe was cross-origin and couldn't be accessed
      }

      documents.push(frameDocumentElement);
    }

    function touchy(type) {
      var touch = {
        mouseup: "touchend",
        mousedown: "touchstart",
        mousemove: "touchmove",
      };
      var pointers = {
        mouseup: "pointerup",
        mousedown: "pointerdown",
        mousemove: "pointermove",
      };
      var microsoft = {
        mouseup: "MSPointerUp",
        mousedown: "MSPointerDown",
        mousemove: "MSPointerMove",
      };

      if (window.navigator.pointerEnabled) {
        return [pointers[type]];
      } else if (window.navigator.msPointerEnabled) {
        return [microsoft[type]];
      } else {
        return [touch[type], type];
      }
    }

    var listeners = [];
    function bind() {
      // add listeners
      documents.forEach(function (doc) {
        touchy("mousedown").forEach(function (type) {
          var g = dispatch(grab, doc);
          g.doc = doc;
          g.type = type;
          listeners.push(g);
        });

        touchy("mouseup").forEach(function (type) {
          var r = dispatch(release, doc);
          r.doc = doc;
          r.type = type;
          listeners.push(r);
        });

        listeners.forEach(function (listener) {
          doc.addEventListener(listener.type, listener);
        });
      });
    }

    function unbind() {
      listeners.forEach(function (listener) {
        listener.doc.removeEventListener(listener.type, listener);
      });

      listeners = [];
    }

    bind();

    function getEventHost(e) {
      // on touchend event, we have to use `e.changedTouches`
      // see http://stackoverflow.com/questions/7192563/touchend-event-properties
      // see https://github.com/bevacqua/dragula/issues/34
      if (e.targetTouches && e.targetTouches.length) {
        return e.targetTouches[0];
      }
      if (e.changedTouches && e.changedTouches.length) {
        return e.changedTouches[0];
      }
      return e;
    }

    function getCoord(coord, e) {
      var host = getEventHost(e);
      var missMap = {
        pageX: "clientX", // IE8
        pageY: "clientY", // IE8
      };

      if (coord in missMap && !(coord in host) && missMap[coord] in host) {
        coord = missMap[coord];
      }

      return host[coord];
    }

    function preventGrabbed(e) {
      if (_grabbed) {
        e.preventDefault();
      }
    }

    function movements(remove) {
      if (remove) {
        documents.forEach(function (doc) {
          doc.removeEventListener("selectstart", preventGrabbed);
          doc.removeEventListener("click", preventGrabbed);
        });
      } else {
        documents.forEach(function (doc) {
          doc.addEventListener("selectstart", preventGrabbed);
          doc.addEventListener("click", preventGrabbed);
        });
      }
    }

    function whichMouseButton(e) {
      if (e.touches !== void 0) {
        return e.touches.length;
      }
      if (e.which !== void 0 && e.which !== 0) {
        return e.which;
      } // see https://github.com/bevacqua/dragula/issues/261
      if (e.buttons !== void 0) {
        return e.buttons;
      }
      var button = e.button;
      if (button !== void 0) {
        // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
        if (button & 1) {
          return 1;
        }
        if (button & 2) {
          return 3;
        }
        if (button & 4) {
          return 2;
        }
        return 0;
      } else {
        return null;
      }
    }

    function getElementBehindPoint(doc, x, y) {
      var el;
      el = doc.elementFromPoint(x, y);
      return el;
    }

    function isEditable(el) {
      if (!el) {
        return false;
      } // no parents were editable
      if (el.contentEditable === "false") {
        return false;
      } // stop the lookup
      if (el.contentEditable === "true") {
        return true;
      } // found a contentEditable element in the chain
      return isEditable(getParent(el)); // contentEditable is set to 'inherit'
    }

    function isInput(el) {
      return el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || isEditable(el);
    }

    function getScroll(doc, scrollProp, offsetProp) {
      var document = doc.ownerDocument,
        window = document.defaultView;

      if (typeof window[offsetProp] !== "undefined") {
        return window[offsetProp];
      }
      if (document.documentElement.clientHeight) {
        return document.documentElement[scrollProp];
      }
      return document.body[scrollProp];
    }

    function start(context) {
      _source = context.source;
      _item = context.item;
      _initialSibling = _currentSibling = nextEl(context.item);

      drake.dragging = true;
      drake.emit("drag", _item, _source);
    }

    function end() {
      if (!drake.dragging) {
        return;
      }
      var item = _item;
      drop(item, getParent(item));
    }

    function drag(doc, e) {
      e.preventDefault();

      var clientX = getCoord("clientX", e);
      var clientY = getCoord("clientY", e);
      var window = doc.ownerDocument.defaultView;
      var offsetX = 0;
      var offsetY = 0;

      if (window.frameElement) {
        var rect = window.frameElement.getBoundingClientRect();
        offsetX = rect.left;
        offsetY = rect.top;
      }

      var x = clientX + offsetX;
      var y = clientY + offsetY;

      var item = _item;
      var elementBehindCursor = getElementBehindPoint(doc.ownerDocument, clientX, clientY);
      var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
      var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
      drake.emit("move", item, _lastDropTarget, _source, elementBehindCursor, x, y);
      if (changed || dropTarget === null) {
        out();
        _lastDropTarget = dropTarget;
        over();
      }
      var parent = getParent(item);
      var reference;
      var immediate = getImmediateChild(dropTarget, elementBehindCursor);
      if (immediate !== null) {
        reference = getReference(dropTarget, immediate, clientX, clientY);
      } else {
        reference = _initialSibling;
        dropTarget = _source;
      }

      if ((reference === null && changed) || (reference !== item && reference !== nextEl(item))) {
        _currentSibling = reference;
      }
      function moved(type) {
        drake.emit(type, item, _lastDropTarget, _source);
      }
      function out() {
        if (_lastDropTarget) {
          moved("out");
        }
      }
      function over() {
        if (changed) {
          moved("over");
        }
      }
    }
    drag.listeners = [];

    function startBecauseMouseMoved(doc, e) {
      if (!_grabbed) {
        return;
      }
      if (whichMouseButton(e) === 0) {
        release(doc, {});
        return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
      }
      // truthy check fixes #239, equality fixes #207
      if (e.clientX !== void 0 && e.clientX === _moveX && e.clientY !== void 0 && e.clientY === _moveY) {
        return;
      }
      var clientX = getCoord("clientX", e);
      var clientY = getCoord("clientY", e);
      var screenX = getCoord("screenX", e);
      var screenY = getCoord("screenY", e);

      var elementBehindCursor = doc.ownerDocument.elementFromPoint(clientX, clientY);
      if (isInput(elementBehindCursor)) {
        return;
      }

      var grabbed = _grabbed; // call to end() unsets _grabbed
      eventualMovements(true);
      movements();
      end();
      start(grabbed);

      drag.listeners = [];
      touchy("mousemove").forEach(function (type) {
        documents.forEach(function (doc) {
          var d = dispatch(drag, doc);
          d.doc = doc;
          d.type = type;
          doc.addEventListener(type, d);
          drag.listeners.push(d);
        });
      });

      drag(doc, e);
    }

    function eventualMovements(remove) {
      if (remove) {
        eventualMovements.listeners.forEach(function (cb) {
          cb.doc.removeEventListener(cb.type, cb);
        });
        eventualMovements.listeners = [];
      } else {
        touchy("mousemove").forEach(function (type) {
          documents.forEach(function (doc) {
            var cb = dispatch(startBecauseMouseMoved, doc);
            cb.type = type;
            cb.doc = doc;
            doc.addEventListener(type, cb);
            eventualMovements.listeners.push(cb);
          });
        });
      }
    }
    eventualMovements.listeners = [];

    function ungrab() {
      _grabbed = false;
      eventualMovements(true);
      movements(true);
    }

    function canStart(item) {
      if (drake.dragging) {
        return;
      }
      if (isContainer(item)) {
        return; // don't drag container itself
      }
      var handle = item;
      while (getParent(item) && isContainer(getParent(item)) === false) {
        item = getParent(item); // drag target should be a top element
        if (!item) {
          return;
        }
      }
      var source = getParent(item);
      if (!source) {
        return;
      }

      if (options.moves && !options.moves(item, source, handle, nextEl(item))) {
        return;
      }

      return {
        item: item,
        source: source,
      };
    }

    function canMove(item) {
      return !!canStart(item);
    }

    function grab(doc, e) {
      _moveX = e.clientX;
      _moveY = e.clientY;

      var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
      if (ignore) {
        return; // we only care about honest-to-god left clicks and touch events
      }
      var item = e.target;
      var context = canStart(item);
      if (!context) {
        return;
      }
      _grabbed = context;
      eventualMovements();

      if (e.type === "mousedown") {
        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
      }
    }

    function getParent(el) {
      if (documents.indexOf(el) === -1) {
        return el.parentNode;
      } else {
        return null;
      }
    }
    function getImmediateChild(dropTarget, target) {
      var immediate = target;
      while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
        immediate = getParent(immediate);
      }
      if (documents.indexOf(immediate) > -1) {
        return null;
      }
      return immediate;
    }

    function isContainer(el) {
      // get the owner doc, see if el is in the results
      // of querying any of the selectors for containers
      return drake.containers().indexOf(el) !== -1;
    }

    function getRectWidth(rect) {
      return rect.width || rect.right - rect.left;
    }
    function getRectHeight(rect) {
      return rect.height || rect.bottom - rect.top;
    }
    function nextEl(el) {
      return el.nextElementSibling || manually();
      function manually() {
        var sibling = el;
        do {
          sibling = sibling.nextSibling;
        } while (sibling && sibling.nodeType !== 1);
        return sibling;
      }
    }

    function getReference(dropTarget, target, x, y) {
      var horizontal = false; //hard coded for now
      var reference = target !== dropTarget ? inside() : outside();
      return reference;

      function outside() {
        // slower, but able to figure out any position
        var len = dropTarget.children.length;
        var i;
        var el;
        var rect;
        for (i = 0; i < len; i++) {
          el = dropTarget.children[i];
          rect = el.getBoundingClientRect();
          if (horizontal && rect.left + rect.width / 2 > x) {
            return el;
          }
          if (!horizontal && rect.top + rect.height / 2 > y) {
            return el;
          }
        }
        return null;
      }

      function inside() {
        // faster, but only available if dropped inside a child element
        var rect = target.getBoundingClientRect();
        if (horizontal) {
          return resolve(x > rect.left + getRectWidth(rect) / 2);
        }
        return resolve(y > rect.top + getRectHeight(rect) / 2);
      }

      function resolve(after) {
        return after ? nextEl(target) : target;
      }
    }

    function findDropTarget(elementBehindCursor, clientX, clientY) {
      var target = elementBehindCursor;
      while (target && !accepted()) {
        target = getParent(target);
      }
      return target;

      function accepted() {
        var droppable = isContainer(target);
        if (droppable === false) {
          return false;
        }
        // could put a customizable check here, passed in as an option
        return true;
      }
    }

    function cleanup() {
      var item = _item;
      ungrab();
      drag.listeners.forEach(function (listener) {
        listener.doc.removeEventListener(listener.type, listener);
      });
      if (_renderTimer) {
        clearTimeout(_renderTimer);
      }
      drake.dragging = false;
      if (_lastDropTarget) {
        drake.emit("out", item, _lastDropTarget, _source);
      }
      drake.emit("dragend", item);
      _source = _item = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
    }

    function drop(item, target) {
      var parent = getParent(item);
      drake.emit("drop", item, target, _source, _currentSibling);
      cleanup();
    }

    function cancel(revert) {
      if (!drake.dragging) {
        return;
      }
      var item = _item;
      var parent = getParent(item);
      drake.emit("cancel", item, _source, _source);
      cleanup();
    }

    function release(doc, e) {
      ungrab(doc);
      if (!drake.dragging) {
        return;
      }
      var item = _item;
      var clientX = getCoord("clientX", e);
      var clientY = getCoord("clientY", e);
      var elementBehindCursor = getElementBehindPoint(doc.ownerDocument, clientX, clientY);
      var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
      if (dropTarget) {
        drop(item, dropTarget);
      } else {
        cancel();
      }
    }

    function remove() {
      if (!drake.dragging) {
        return;
      }
      var item = _item;
      var parent = getParent(item);
      if (parent) {
        parent.removeChild(item);
      }
      drake.emit("remove", item, parent, _source);
      cleanup();
    }

    return drake;
  }

  window.dragulish = dragulish;
})();
